import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginView from "../components/authentication/LoginView.vue";
import Home from "../components/Home.vue";
import FolderAuthenticationView from "../components/authentication/FolderAuthenticationView.vue";
import FileListView from "../components/file/FileListView.vue";
import ErrorView from "../components/ErrorView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/Login",
    name: "ログイン",
    component: LoginView,
    props: r => ({
      redirect: r.query.redirect,
    })
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/Authentication",
    name: "Authentication",
    component: FolderAuthenticationView,
    props: r => ({
      guid: r.query.guid,
      redirect: r.query.redirect,
    })
  },
  {
    path: "/FileList",
    name: "FileList",
    component: FileListView,
    meta: { requiresFolderAuth: true },
    props: r => ({
      folderGuid: r.query.folderGuid,
    })
  },
  {
    path: "/Error",
    name: "Error",
    component: ErrorView,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
